var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.738 27.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 31"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 62",
    d: "m16.418.042.027.015Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 63",
    d: "M16.308.002a.4.4 0 0 1 .109.04.4.4 0 0 0-.109-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 64",
    d: "M16.445.057a.342.342 0 0 1 .094.079.428.428 0 0 0-.094-.079Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 66",
    d: "M8.333 5.28a.456.456 0 0 0-.456-.456H2.733a.456.456 0 1 0 0 .912h5.141a.456.456 0 0 0 .459-.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 67",
    d: "M2.733 3.644h7.51a.456.456 0 0 0 0-.912h-7.51a.456.456 0 1 0 0 .912Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 68",
    d: "M21.729 5.426a.381.381 0 0 0-.04-.112v-.021a.387.387 0 0 0-.073-.1L16.539.137a.346.346 0 0 0-.094-.07l-.027-.024a.393.393 0 0 0-.109-.04.427.427 0 0 0-.088 0H.453a.456.456 0 0 0-.45.438v27a.456.456 0 0 0 .456.456h20.826a.456.456 0 0 0 .456-.456V5.514a.467.467 0 0 0-.012-.088Zm-1.548-.368h-3.508V1.549Zm.645 21.921H.912V.905h14.849v4.609a.456.456 0 0 0 .456.456h4.609Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 69",
    d: "M15.454 9.618v3.536h-1.666v-1.538a.456.456 0 1 0-.912 0v1.538h-1.669V8.931a.456.456 0 0 0-.912 0v4.223H8.622v-5a.456.456 0 1 0-.912 0v5H6.044v-2.781a.456.456 0 0 0-.912 0v2.782h-1.04a.456.456 0 1 0 0 .912h13.539a.456.456 0 1 0 0-.912h-1.268V9.618a.456.456 0 1 0-.912 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 70",
    d: "M16.606 22.993h-3.764a.456.456 0 1 0 0 .912h3.764a.456.456 0 1 0 0-.912Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 71",
    d: "M18.324 20.901h-5.473a.456.456 0 0 0 0 .912h5.473a.456.456 0 0 0 0-.912Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 72",
    d: "M12.386 19.269a.456.456 0 0 0 .456.456h5.473a.456.456 0 0 0 0-.912h-5.473a.456.456 0 0 0-.456.456Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Caminho 73",
    d: "M6.995 17.314a4.047 4.047 0 1 0 4.05 4.046 4.047 4.047 0 0 0-4.05-4.046ZM5.98 21.36a1.019 1.019 0 1 1 1.015 1.022A1.022 1.022 0 0 1 5.98 21.36Zm.563-3.1v1.216a1.933 1.933 0 0 0-1.475 1.873 1.9 1.9 0 0 0 .283 1l-.863.888a3.125 3.125 0 0 1 2.055-4.965Zm.45 6.23a3.114 3.114 0 0 1-1.867-.608l.863-.867a1.923 1.923 0 0 0 2.879-1.192h1.216a3.138 3.138 0 0 1-3.089 2.669Zm1.882-3.591a1.937 1.937 0 0 0-1.42-1.417v-1.213a3.138 3.138 0 0 1 2.642 2.639Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.04e4afe715ad95e37ac1a4801d11b1a3.svg";
export { ForwardRef as ReactComponent };